import _ from 'lodash';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

interface IProps {
  children: any;
}

const NMIContainer = ({ children }: IProps) => {
  const [ready, setReady] = useState(false);
  const branch = useSelector((state: any) => state.app.branch);
  const collectJsUrl = 'https://secure.networkmerchants.com/token/Collect.js';

  useEffect(() => {
    if (!(window as any).CollectJS) {
      const script = document.createElement('script');
      script.src = collectJsUrl;
      script.dataset.tokenizationKey = _.get(branch, 'payment.publicKey');

      script.dataset.customCss = `{
        "font-size": "15px"
      }`;

      script.dataset.placeholderCss = `{
        "color": "lightgray"
      }`;

      script.onload = () => setReady(true);
      document.body.appendChild(script);
    } else {
      setReady(true);
    }
  }, []);

  if (!ready) {
    return null;
  }

  return <div id="nmi-container">{children}</div>;
};

export default NMIContainer;
